import { AnyAction, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { createWidgetTypes } from '@/store/types/createWidgetTypes';
import createFormSlice from '@/store/reducers/createFormSlice';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '@/api/apiConfig';
import { selectAllowDomains } from '@/store/selectors/domainsListSelector';
import { selectTestId } from '@/store/selectors/testIdSelector';
import { handleResponseError } from '@/core/utils/handleResponseError';
import { fetchData } from '@/core/utils/fetchData';
import { apiUrl } from '@/api/axios';
import { RootState } from '@/store/store';

const initialWidgetState: createWidgetTypes = {
	key: 'REPLACE_KEY',
	isExisting: false,
};

const createWidgetSlice = createFormSlice('createWidget', initialWidgetState);

const combinedSlice = createSlice({
	name: 'createWidget',
	initialState: createWidgetSlice.getInitialState(),
	reducers: {
		...createWidgetSlice.caseReducers,
		setKey(state, action: PayloadAction<string>) {
			state.data.key = action.payload;
		},

		setIsExisting(state, action: PayloadAction<boolean>) {
			state.data.isExisting = action.payload;
		},
	},
});

export const {
	resetSuccessMessage,
	setError,
	setKey ,
	setIsExisting
} = combinedSlice.actions;


export const fetchIsWidgetExisting = (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
	async (dispatch, getState) => {
		const state = getState();
		const testId = selectTestId(state);

		try {
			const requestUrl = `${API_ENDPOINTS.checkWidgetExisting}${testId}`;
			const response = await apiUrl.get(requestUrl);
			const data = response.data.data;

			dispatch(setKey(data.key));
			dispatch(setIsExisting(data.exits));
		} catch (error) {
			handleResponseError(error, (data) => dispatch(setError(data)));
		}
	};
export const sendDataToGenerate = () => async (dispatch, getState) => {
	try {
		const state = getState();
		const testId = selectTestId(state);
		const domainList = selectAllowDomains(state);

		const data = {
			test_id: testId,
			allow_domains: [...domainList]
		};

		const response = await dispatch(sendForm(combinedSlice, API_ENDPOINTS.postWidget, 'validation.success_message')(data));

		if (response?.data?.data?.key) {
			dispatch(setKey(response.data.data.key));
			return true;
		}
	} catch (error) {
		handleResponseError(error, (data) => dispatch(setError(data)));
		return false;
	}
};


export default combinedSlice.reducer;
export { combinedSlice as createWidgetSlice };